import { StyleRoot } from "@redotech/react-util/style";
import { WidgetAutocheck } from "@redotech/redo-model/widget";
import { ShopifyAjaxClient } from "@redotech/shopify-client/ajax";
import { createRoot } from "react-dom/client";
import { RedoShopifyRpcClientContextProvider } from "../client/redo-shopify-rpc-client";
import { log } from "../monitoring/log";
import { MuiRoot, REDO_STOREFRONT_OVERLAY_CONTAINER } from "../redo-storefront";
import { RedoRoot } from "../root";
import { ExtensionShopifyClientContext } from "../shopify";
import STYLE_MANAGER from "../style-manager";
import { BackInStockPdpButtonEntryPoint } from "./back-in-stock-pdp-button-entry";

export const BACK_IN_STOCK_PDP_BUTTON_CONTAINER_ID =
  "redo-back-in-stock-pdp-button";

/**
 * Initializes the Back in Stock PDP button component
 * @param autocheck Widget autocheck configuration
 */
export function initialize(autocheck: WidgetAutocheck) {
  log("Initializing Back in stock PDP button");

  const container = document.getElementById(
    BACK_IN_STOCK_PDP_BUTTON_CONTAINER_ID,
  );

  const redoContainer = document.getElementById(
    REDO_STOREFRONT_OVERLAY_CONTAINER,
  );

  if (!container || !redoContainer) {
    return;
  }

  log("Found Back in stock PDP button container and redo container");

  const root = createRoot(container);
  root.render(
    <StyleRoot container={container} styleManager={STYLE_MANAGER}>
      <MuiRoot container={redoContainer}>
        <RedoRoot
          extensionShopifyClient={undefined}
          storeUrl={
            window.redoStorefront?.storeUrl ??
            window.Shopify?.shop ??
            window.Shopify?.Checkout?.apiHost
          }
        >
          <RedoShopifyRpcClientContextProvider
            baseUrl={
              window.redoStorefront?.env?.REDO_SHOPIFY_SERVER_URL ??
              process.env.REDO_SHOPIFY_SERVER_URL!
            }
            storeUrl={window.Shopify?.shop ?? window.Shopify?.Checkout?.apiHost}
            widgetId={window.redoWidgetId}
          >
            <ExtensionShopifyClientContext.Provider
              value={ShopifyAjaxClient.fromEnv()}
            >
              <BackInStockPdpButtonEntryPoint autocheck={autocheck} />
            </ExtensionShopifyClientContext.Provider>
          </RedoShopifyRpcClientContextProvider>
        </RedoRoot>
      </MuiRoot>
    </StyleRoot>,
  );
}
